import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Grid from "@mui/material/Grid2";
import {
  Box,
  Button,
  Divider,
  FormControl,
  Modal,
  Typography,
} from "@mui/material";
import { useMsal } from "@azure/msal-react";

import fontWeight from "../../styles/mui/fontWeight";
import { colors } from "../../styles/colors";
import { FormInputText } from "../../components/FormInputText";
import { TextfieldStyle } from "../../routes/Training/styles/style";
import {
  CancelButton,
  DisplayItemCenter,
  ForgotPasswordGridContainer,
  ForgotPasswordModalBox,
  HorizontalDivider,
} from "../styles/styles";
import { Asterisk } from "../../styles/common/style";
import { rules } from "../../utils/validation/Validation";
import { flexAllCentre } from "../../styles/mui/styles/display";
import {
  LoginCircle1,
  LoginCircle2,
  LoginCircle3,
  LoginCircle4,
  LoginCircle5,
  Min_Vh_100,
} from "../../loginResources/backgroundStyle";
import { redirectUri } from "../../constants/Config";
import { Logout } from "../../utils";

interface SendLink {
  email: string;
}

export interface PropsFromDispatch {
  sendForgotPasswordLink: (payload: SendLink) => void;
}

export interface PropsFromState { 
  forgotLinkState: any;
}

type AllProps = PropsFromDispatch & PropsFromState;

const ForgotPassword: React.FC<AllProps> = ({ sendForgotPasswordLink, forgotLinkState }) => {
  const methods = useForm<SendLink>({
    defaultValues: {
      email: "",
    },
  });

  const { control, handleSubmit } = methods;
  const { instance } = useMsal();

  const onSubmit = (data: SendLink) => {
    sendForgotPasswordLink({ email: data?.email });
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Enter") {
      handleSubmit(onSubmit)();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (forgotLinkState === true) {
      Logout(redirectUri, instance);
    }
    if (forgotLinkState === true) {
      Logout(redirectUri, instance);
    }
  }, [forgotLinkState]);

  const label = (label: string) => {
    return (
      <Grid size={{ xs: 12 }} sx={DisplayItemCenter(true)}>
        <Typography
          variant="h3"
          color={colors.portalColor[2]}
          fontWeight={fontWeight[5]}
        >
          {label}
        </Typography>
        <Typography
          variant="subtitle1"
          color={colors.red[90]}
          fontWeight={fontWeight[4]}
          pr={2}
          sx={Asterisk}
        >
          *
        </Typography>
      </Grid>
    );
  };

  const [open, setOpen] = useState<boolean>(true);
  const handleModalClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={Min_Vh_100}>
      <Box sx={LoginCircle1}></Box>
      <Box sx={LoginCircle2}></Box>
      <Box sx={LoginCircle3}></Box>
      <Box sx={LoginCircle4}></Box>
      <Box sx={LoginCircle5}></Box>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        onClose={handleModalClose}
        hideBackdrop
        sx={flexAllCentre}
      >
        <Box sx={ForgotPasswordModalBox}>
          <Grid container sx={ForgotPasswordGridContainer}>
            <Grid size={{ xs: 12 }}>
              <Typography
                variant="h1"
                fontWeight={fontWeight[3]}
                color={colors.portalColor[2]}
                fontSize={"1.5rem"}
                align="left"
                pb={1}
              >
                Forgot Your Password
              </Typography>
              <Divider sx={HorizontalDivider} />
              <Typography
                variant="subtitle1"
                fontWeight={fontWeight[3]}
                color={colors.portalColor[2]}
                fontSize={"1rem"}
                align="left"
                pb={1}
              >
                Please enter the email address you would like your password
                reset information sent to
              </Typography>
            </Grid>
            <Grid size={{ xs: 12 }} pt={2}>
              {label("Enter Email Address")}
              <FormControl variant="standard" fullWidth>
                <FormInputText
                  name="email"
                  control={control}
                  style={TextfieldStyle}
                  helper={rules.email}
                />
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12 }} pt={2} sx={DisplayItemCenter(false)}>
              <Button variant="contained" onClick={handleSubmit(onSubmit)}>
                Submit
              </Button>
              <Button variant="contained" onClick={() => {
                Logout(redirectUri, instance)
                Logout(redirectUri, instance)
                handleModalClose()
               }} sx={CancelButton}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Box>
  );
};

export default ForgotPassword;
